(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/widget-area/assets/javascripts/load-area.js') >= 0) return;  svs.modules.push('/components/core/widget-area/assets/javascripts/load-area.js');

'use strict';

var _excluded = ["fetchDataUrl"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function loadArea(area, className, finalCallback) {
  if (finalCallback === undefined) {
    finalCallback = className;
    className = undefined;
  }
  var widgets = svs.widgets.data[area];
  if (widgets) {
    var widgetsToLoad = widgets
    .filter(function (widget) {
      return widget.data && widget.data.fetchDataUrl;
    })
    .map(function (widget) {
      var d = $.Deferred();
      var widgetName = widget.widget;
      var widgetComponent = svs.widget[widgetName];
      if (widgetComponent && widgetComponent.fetchData) {
        var _widget$data = widget.data,
          url = _widget$data.fetchDataUrl,
          data = _objectWithoutProperties(_widget$data, _excluded);
        widgetComponent.fetchData({
          area: area,
          url: url
        }, data, function (err, completeData) {
          if (completeData) {
            widget.data = completeData;
            widget.partial = "widget-".concat(widgetName, "-").concat(Object.keys(widgetComponent.templates)[0]);
          }
          d.resolve();
        });
      } else {
        d.resolve();
      }
      return d;
    });

    $.when.apply(this, widgetsToLoad).then(function () {
      var templateString = Handlebars.helpers.widgetArea({
        hash: {
          name: area,
          class: className
        }
      });
      finalCallback(templateString);
    }, function () {
      finalCallback(); 
    });
  } else {
    finalCallback();
  }
}
svs.core.widget_area.loadArea = loadArea;

 })(window);